import { useEffect, useState } from 'react'

type Options = {
  maxHeight: number
  isMobileFullscreen?: boolean
}

/**
 * Hook that make *hot-dropdown* height's responsive
 *
 * @param hotDropdownRef useRef to `<hot-dropdown />` element
 * @param options Options to hot-dropdown behavior
 */
export const useResponsiveHotDropdown = (hotDropdownRef: JSX.IntrinsicElements['hot-dropdown'], options: Options) => {
  const { maxHeight, isMobileFullscreen } = options
  const DROPDOWN_MARGIN_BOTTOM = 120
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - DROPDOWN_MARGIN_BOTTOM)

  useEffect(() => {
    const updateWindowHeight = () => setWindowHeight(window.innerHeight - DROPDOWN_MARGIN_BOTTOM)

    const hotDropdown = hotDropdownRef.current
    const style = document.createElement('style')

    if (hotDropdown && hotDropdown.shadowRoot) {
      style.innerHTML = `
        :host .hot-dropdown__menu {
          height: auto;
          max-height: ${maxHeight > windowHeight ? windowHeight : maxHeight}px;
          overflow-y: auto;
        }

        ${
          isMobileFullscreen
            ? `
        @media (max-width: 768px) {
          :host .hot-dropdown__menu {
            height: 100%;
            max-height: initial;
          }
        }
        `
            : null
        }
      `
      hotDropdown.shadowRoot.appendChild(style)
      window.addEventListener('resize', updateWindowHeight)
    }

    return () => {
      style.remove()
      window.removeEventListener('resize', updateWindowHeight)
    }
  })
}
